import { render } from "./ManagementPage.vue?vue&type=template&id=25d0a99d&scoped=true&lang=pug"
import script from "./ManagementPage.vue?vue&type=script&lang=js"
export * from "./ManagementPage.vue?vue&type=script&lang=js"

import "./ManagementPage.vue?vue&type=style&index=0&id=25d0a99d&lang=scss&scoped=true"
import "./ManagementPage.vue?vue&type=style&index=1&id=25d0a99d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d0a99d"]])

export default __exports__